import React, { Component } from 'react'
import PropTypes from 'prop-types'
import LinesEllipsis from 'react-lines-ellipsis'

class TableOfContents extends Component {

    static propTypes = {
        onClick: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
        page: PropTypes.string.isRequired,
    }

    render() {
        const { onClick, title, page } = this.props

        return (
            <div
                onClick={onClick}
                title={title}
                className='title'
            >
                <LinesEllipsis
                    text={ title }
                    maxLine='2'
                    className="title"
                />

                <div className="page">{ page }</div>
            </div>

        )
    }
}

export default TableOfContents
